export default {
  "content": "<rect width=\"2.667\" height=\"3.333\" x=\"3.333\" y=\"9.333\" fill=\"#fff\" fill-opacity=\".17\" rx=\"1\"/><rect width=\"2.667\" height=\"6.667\" x=\"6.667\" y=\"6\" fill=\"#fff\" fill-opacity=\".17\" rx=\"1\"/><rect width=\"2.667\" height=\"9.333\" x=\"10\" y=\"3.333\" fill=\"#fff\" fill-opacity=\".17\" rx=\"1\"/><path stroke=\"#EA3917\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M4 4l8 8\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};